import 'react-datepicker/dist/react-datepicker.css';
import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';

import Visible from 'coreOld/components/Visible';
import { DateInput, FormError, Label } from 'coreOld/elements';
import { Size } from 'coreOld/enums';

import { DatePickerStyled } from './dateInputStyled';

interface IProps {
  name?: string;
  control?: Control<FieldValues, object>;
  required?: boolean;
  label?: string;
  placeholder?: string;
  timeInputLabel?: string;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  selected?: Date;
  selectsEnd?: boolean;
  selectsStart?: boolean;
  dateFormat?: string;
  showTimeInput?: boolean;
  size?: Size;
  showBorder?: boolean;
  hasBorder?: boolean;
  selectsRange?: boolean;
  monthsShown?: number;
  inline?: boolean;
  onChange?;
  error?: FieldError;
  showFieldError?: boolean;
  isDisabledState?: boolean;
  isEditable?: boolean;
  isClearable?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
}

const DateInputWithControllerView = ({
  name,
  control,
  startDate,
  endDate,
  minDate,
  onChange,
  selectsEnd,
  selectsStart,
  dateFormat,
  showTimeInput = false,
  timeInputLabel,
  label,
  required = false,
  selected,
  size,
  showBorder = false,
  hasBorder = true,
  selectsRange = false,
  monthsShown,
  inline,
  placeholder,
  error,
  showFieldError = false,
  isDisabledState = false,
  isClearable = false,
  showMonthDropdown = false,
  showYearDropdown = false,
}: IProps) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <Visible when={Boolean(label)}>
              <Label label={label} required={required} />
            </Visible>

            <DateInput
              size={size}
              showBorder={showBorder}
              selectsRange={selectsRange}
              hasBorder={hasBorder}
              isDisabledState={isDisabledState}
            >
              <DatePickerStyled
                {...{
                  ...field,
                  dateFormat,
                  showTimeInput,
                  timeInputLabel,
                  onChange: (date) => {
                    field.onChange(date);

                    onChange && onChange(date);
                  },
                  startDate,
                  endDate,
                  minDate,
                  selected: selected || field.value,
                  selectsEnd,
                  selectsStart,
                  selectsRange,
                  inline,
                  monthsShown,
                  placeholderText: isDisabledState ? '-' : placeholder,
                  error,
                  disabled: isDisabledState,
                  isClearable,
                  showMonthDropdown,
                  showYearDropdown,
                }}
              />
            </DateInput>
          </>
        )}
      />
      {error && showFieldError && <FormError error={error} />}
    </>
  );
};

export default DateInputWithControllerView;
